export function formatAuctionDate(value: string | null): string {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return value;
  }
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'America/Chicago',
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).formatToParts(date);
  const get = (type: string) => {
    const part = parts.find(item => item.type === type);
    return part ? part.value : '';
  };
  return get('day') + '-' + get('month') + '-' + get('year') + ' '
    + get('hour') + ':' + get('minute') + ':' + get('second');
}

export function formatTotalAmount(amount: number | null): string {
  return '$' + (amount || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export function auctionDetailPath(auctionId: string | null): string {
  return '/editauction/EDIT/' + (auctionId || '') + '/0/0/1/0/0';
}
